import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getGqlUrl } from '@chegg/utils';
import { RIO_HOST_NAMES } from '../../queries';
import { GET_HOST_NAMES_LOGGING_KEY, RETRIES, Severity } from '../../types';
import { retryOperation } from '../../utils';
import { captureError } from '../../utils/newRelicLogging';
import apolloClient from './apolloClient';

/**
 * Fetch rioHostNames with the GraphQL query {@link RIO_HOST_NAMES}
 */
var fetchingHostNames = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _data$rioHostNames, _data$rioHostNames$ga, _data$rioHostNames2, _data$rioHostNames2$g;
    var client, _yield$client$query, data, errors, primaryHostName, secondaryHostName;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          client = apolloClient();
          _context.next = 3;
          return client.query({
            query: RIO_HOST_NAMES,
            errorPolicy: 'all'
          });
        case 3:
          _yield$client$query = _context.sent;
          data = _yield$client$query.data;
          errors = _yield$client$query.errors;
          primaryHostName = data === null || data === void 0 ? void 0 : (_data$rioHostNames = data.rioHostNames) === null || _data$rioHostNames === void 0 ? void 0 : (_data$rioHostNames$ga = _data$rioHostNames.gateway) === null || _data$rioHostNames$ga === void 0 ? void 0 : _data$rioHostNames$ga.primaryHostName;
          secondaryHostName = data === null || data === void 0 ? void 0 : (_data$rioHostNames2 = data.rioHostNames) === null || _data$rioHostNames2 === void 0 ? void 0 : (_data$rioHostNames2$g = _data$rioHostNames2.gateway) === null || _data$rioHostNames2$g === void 0 ? void 0 : _data$rioHostNames2$g.secondaryHostName;
          if (!(errors || !data || !primaryHostName && !secondaryHostName)) {
            _context.next = 10;
            break;
          }
          throw Error('Unable to get host names');
        case 10:
          return _context.abrupt("return", {
            primaryHostName: primaryHostName,
            secondaryHostName: secondaryHostName
          });
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchingHostNames() {
    return _ref.apply(this, arguments);
  };
}();

// asynchronous function that returns primary and secondary hostnames by calling fetchingHostNames
// and retrying it 'retries' number of times incase of failure
var getRioHostNames = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var retries,
      _yield$retryOperation,
      primaryHostName,
      secondaryHostName,
      message,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          retries = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : RETRIES;
          _context2.prev = 1;
          _context2.next = 4;
          return retryOperation({
            operation: fetchingHostNames,
            maxRetries: retries
          });
        case 4:
          _yield$retryOperation = _context2.sent;
          primaryHostName = _yield$retryOperation.primaryHostName;
          secondaryHostName = _yield$retryOperation.secondaryHostName;
          return _context2.abrupt("return", {
            primaryHostName: primaryHostName,
            secondaryHostName: secondaryHostName
          });
        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](1);
          message = "getHostNames Last Retry :: ".concat(_context2.t0, " onegraphEndpoint: ").concat(getGqlUrl(window.location.hostname));
          captureError({
            error: message,
            location: GET_HOST_NAMES_LOGGING_KEY,
            severity: Severity.ERROR
          }, {
            message: message
          });
          return _context2.abrupt("return", {});
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 10]]);
  }));
  return function getRioHostNames() {
    return _ref2.apply(this, arguments);
  };
}();
export default getRioHostNames;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio2-web-client/dist/esm/client/https/fetchAllHostNames.js
// module id = 4142
// module chunks = 11